import MUIFormLabel from '@mui/material/FormLabel'; // Note that this implicitly renames the import from FormLabel to MUIFormLabel to avoid naming conflicts below. The MUI component is NOT named MUIFormLabel.
import type { JSX } from 'react';
import { FormLabel as BootstrapFormLabel } from 'react-bootstrap';

import { Colors } from 'Components/Colors';
import { VisualLabel } from 'Components/VisualLabel/VisualLabel';

interface FormLabelProps {
    color?: Colors;
    htmlFor?: string;
    required?: boolean;
    hideRequiredSymbol?: boolean;
    tooltip?: string;
    children: string;
}

export const FormLabel = (props: FormLabelProps): JSX.Element => {
    return (
        <BootstrapFormLabel htmlFor={props.htmlFor}>
            <VisualLabel color={props.color} required={props.required && !props.hideRequiredSymbol} tooltip={props.tooltip}>
                {props.children}
            </VisualLabel>
        </BootstrapFormLabel>
    );
};

export interface MaterialFormLabelProps {
    children: string;
    color?: Colors;
    id?: string;
    required?: boolean;
}

/**
 * Renders a **semantic** label that labels a specific form field.
 * Differs from `FormLabel` in that this component is intended to be used with Material UI form fields.
 *
 * NOTE: Tooltips are currently not able to be included, because A) Our tooltips come from Bootstrap, and we should avoid mixing MUI and Bootstrap components, and B) At the time of writing, none of our components that use this flavor of label require tooltips.
 * * If tooltips are added to this component in the future, avoid passing in tooltips that use components from Bootstrap.
 */
export const MaterialFormLabel = (props: MaterialFormLabelProps): JSX.Element => {
    return (
        <MUIFormLabel id={props.id}>
            <VisualLabel color={props.color} required={props.required}>
                {props.children}
            </VisualLabel>
        </MUIFormLabel>
    );
};
